module.exports = __webpack_public_path__ + "static/media/hu.9782e99e.svg";